module.exports = __webpack_public_path__ + "media/images/common/ico-search-bc80a8bb719f5be2a446838f188a9ae2.svg";